export default class VersionsModel {
  public updatedAt: string = "";
  public content: string = "";
}
